export default __webpack_public_path__ + "static/expertise-d60f0e4e327c5591f5a27aacb8836cd0.png";